<template>
    <div class="has-text-centered con">
    <div v-if="after_checksum">
      <div>
        Please press button to continue..
        <br/>
        Amount <i class="fa fa-rupee"></i><b>{{genChecksum.TXN_AMOUNT}}</b><br><br>
        <div>
        <form method="post" action="https://securegw.paytm.in/theia/processTransaction">
        <!--  <form method="post" action="https://pguat.paytm.com/oltp-web/processTransaction"> --><!-- staging -->
            <input type="hidden" name="MID" v-model="genChecksum.MID">
            <input type="hidden" name="ORDER_ID" v-model="genChecksum.ORDER_ID">
            <input type="hidden" name="CUST_ID" v-model="genChecksum.CUST_ID">
            <input type="hidden" name="INDUSTRY_TYPE_ID" v-model="genChecksum.INDUSTRY_TYPE_ID">
            <input type="hidden" name="CHANNEL_ID" v-model="genChecksum.CHANNEL_ID">
            <input type="hidden" name="WEBSITE" v-model="genChecksum.WEBSITE">
            <input type="hidden" name="CALLBACK_URL" v-model="genChecksum.CALLBACK_URL">
            <input type="hidden" name="CHECKSUMHASH" v-model="genChecksum.checksum">
            <input type="hidden" name="TXN_AMOUNT" v-model="genChecksum.TXN_AMOUNT">
            <input type="hidden" name="MERC_UNQ_REF" v-model="genChecksum.MERC_UNQ_REF">
            <input type="hidden" name="promo_code_id" v-model="promoCodeId" />
            <input type="hidden" name="cashback_amount" v-model="cashback" />
            <input id="pay" class="button5" value="Continue" type="submit"  v-on:click="isLoading=true">
          </form>
        </div>
      </div>
      
    </div>
    </div>
</template>
<script>
  import axios from 'axios'

export default{
    data () {
    return {
        urlInterface: [],
        after_checksum: false,
        genChecksum: {},
        promoCodeId:"0",
        cashback:"0"
    }
},
mounted() {
    this.paytm()
},
methods:{
    paytm(){
        var orderId = ''
        const params = new URLSearchParams()
        var userId = this.$route.query.USER_ID;
        this.promoCodeId = this.$route.query.PROMO_CODE_ID;
        this.cashback = this.$route.query.CASHBACK;
        
        params.append('user_id', userId)
        params.append('gateway_name', 'paytm')
        axios({
          url: process.env.BASE_API + '/accounts/generate-unique-order-id',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.urlInterface = {}
          if (response.data.msg.trim().toUpperCase() === 'SUCCESS') {
            orderId = response.data.unique_order_id
            const params = new URLSearchParams()
            
              var txnAmount = this.$route.query.TXN_AMOUNT;
              this.urlInterface.callback_url = process.env.PAGE_URL + '/controllers/pgResponse.php'
              this.urlInterface.vue_url  = "http:localhost:4000/#/a/"
              this.isLoading = false
              console.log(txnAmount)
              params.append('CUST_ID', userId)
              params.append('ORDER_ID', orderId)
              params.append('CHANNEL_ID', 'WEB')
              params.append('WEBSITE', 'SanjeeWEB')
              params.append('TXN_AMOUNT', txnAmount)
              params.append('MERC_UNQ_REF', userId + 'br' + this.urlInterface.vue_url + 'br' + process.env.BASE_API + '/accounts/verify-transaction')
              params.append('CALLBACK_URL', this.urlInterface.callback_url)
              params.append('promo_code_id', this.promoCodeId)
              params.append('cashback_amount', this.cashback)
              axios({
                url: process.env.BASE_API + '/accounts/generate-checksum',
                method: 'post',
                data: params,
                withCredentials: false,
                headers: {
                }
              })
              .then(response => {
                this.genChecksum = {}
                this.genChecksum.MID = response.data.post_value.MID
                this.genChecksum.ORDER_ID = response.data.post_value.ORDER_ID
                this.genChecksum.CUST_ID = this.$route.query.USER_ID
                this.genChecksum.INDUSTRY_TYPE_ID = response.data.post_value.INDUSTRY_TYPE_ID
                this.genChecksum.CHANNEL_ID = response.data.post_value.CHANNEL_ID
                this.genChecksum.WEBSITE = response.data.post_value.WEBSITE
                this.genChecksum.TXN_AMOUNT = this.$route.query.TXN_AMOUNT
                this.genChecksum.CALLBACK_URL = response.data.post_value.CALLBACK_URL
                this.genChecksum.MERC_UNQ_REF = response.data.post_value.MERC_UNQ_REF
                this.genChecksum.checksum = response.data.checkSum
                this.after_checksum = true
                this.userData = false
                this.app_payment_gate = false
                
                if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
                  this.list = response.data.user_record
                  alert(this.list)
                }
              })
              .catch(e => {
                alert('not ok')
              })
            }
        })
        .catch(e => {
          this.errors = 'Server error, Try again!'
          this.isActive = true
        })
      },
        }
}
</script>
<style>
.con{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 70vh;
    font-size:20px ;
}
.loading-icon:before {content: "Wait...";}
.loading-overlay .loading-icon:after {
  animation: spinAround 500ms infinite linear;
  border: 2px solid #3CB6C3;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  height: 1em;
  position: relative;
  width: 1em;
  position: absolute;
  top: calc(50% - 1.5em);
  left: calc(50% - 1.5em);
  width: 3em;
  height: 3em;
  border-width: 0.25em;
}
.button5 {
    background-color: #3CB6C3;
    padding: 5px 20px 5px 20px; 
    color: white; 
    border: none; border-radius: 5% 5% 5% 5%;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/PaytmContd.vue